import { render, staticRenderFns } from "./uploadNewExpression.vue?vue&type=template&id=b8e9f790&scoped=true&"
import script from "./uploadNewExpression.vue?vue&type=script&lang=js&"
export * from "./uploadNewExpression.vue?vue&type=script&lang=js&"
import style0 from "./uploadNewExpression.vue?vue&type=style&index=0&id=b8e9f790&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e9f790",
  null
  
)

export default component.exports